import { Pagination, PaginationItem } from "@mui/material";
import { useEffect, useState } from "react";

type Props = {
  handlePage: (page: number) => void;
  page: number;
  total: number;
  itemsPerPage?: number;
};

export default function Paginations({
  handlePage,
  page,
  total,
  itemsPerPage = 10,
}: Props) {
  const [counter, setCounter] = useState<number>(page);

  useEffect(() => {
    setCounter(page);
  }, [page]);

  const totalPages = Math.ceil(total / itemsPerPage);

  const onChangeHandler = (_: React.ChangeEvent<unknown>, value: number) => {
    setCounter(value);
    handlePage(value);
  };

  return (
    <Pagination
      count={totalPages}
      page={counter}
      onChange={onChangeHandler}
      color="primary"
      shape="rounded"
      size="medium"
      sx={{
        display: "flex",
        flexWrap: { xs: "nowrap", md: "wrap" },
        overflowX: { xs: "auto", md: "visible" },
        "& .MuiPagination-ul": {
          flexWrap: { xs: "nowrap", md: "wrap" },
        },
        "& .MuiPaginationItem-root": {
          color: "#000",
          border: "1px solid #1c4e38",
          fontSize: { xs: "0.75rem", md: "0.875rem" },
          minWidth: { xs: "28px", md: "32px" },
          height: { xs: "28px", md: "32px" },
          padding: { xs: "0 4px", md: "0 6px" },
          margin: { xs: "0 2px", md: "0 3px" },
        },
        "& .MuiPaginationItem-root.Mui-selected": {
          backgroundColor: "#1c4e38",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#155e2e",
          },
        },
        "& .MuiPaginationItem-root:hover": {
          backgroundColor: "#1c4e38",
          color: "#fff",
        },
      }}
      renderItem={(item) => (
        <PaginationItem
          {...item}
          // hide first & last buttons
          slots={{ first: () => null, last: () => null }}
        />
      )}
    />
  );
}
